<template>
  <NavbarFive class="home_one" />
  <ResponsiveNavbarFive class="home_one" />
  <PageBanner pageTitle="Product Details" mainTitle="Product Details" />
  <ProductDetails />
  <RelatedProducts />
  <DownloadTheApp />
  <MainFooter />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import NavbarFive from "../components/Layouts/NavbarFive.vue";
import ResponsiveNavbarFive from "../components/Layouts/ResponsiveNavbarFive.vue";
import PageBanner from "../components/Common/PageBanner.vue";
import ProductDetails from "../components/ProductDetails/ProductDetails.vue";
import RelatedProducts from "../components/ProductDetails/RelatedProducts.vue";
import DownloadTheApp from "../components/Common/DownloadTheApp.vue";
import MainFooter from "../components/Layouts/MainFooter.vue";

export default defineComponent({
  name: "ProductDetailsPage",
  components: {
    NavbarFive,
    ResponsiveNavbarFive,
    PageBanner,
    ProductDetails,
    RelatedProducts,
    DownloadTheApp,
    MainFooter,
  },
});
</script>